import { render, staticRenderFns } from "./Medicines.vue?vue&type=template&id=32772e3d&scoped=true&"
import script from "./Medicines.vue?vue&type=script&lang=js&"
export * from "./Medicines.vue?vue&type=script&lang=js&"
import style0 from "./Medicines.vue?vue&type=style&index=0&id=32772e3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32772e3d",
  null
  
)

export default component.exports